'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Container from './container'
import PicFSUpload from '../../../../../Common/picFSUpload';

const Loading = ({ style }) => {
    return <div style={style}>loading...</div>;
};
Loading.propTypes = {
    style: PropTypes.object
};

const Toggle = ({ style }) => {
    const { height, width } = style;
    const midHeight = height * 0.5;
    const points = `0,0 0,${height} ${width},${midHeight}`;

    return (
        <div style={style.base}>
            <div style={style.wrapper}>
                <svg height={height} width={width}>
                    <polygon points={points}
                        style={style.arrow} />
                </svg>
            </div>
        </div>
    );
};
Toggle.propTypes = {
    style: PropTypes.object
};

const Header = (props) => {
    props.node.i = props.index
    if (props.node.root) {
        return (
            <div style={props.style.base}>
                <div style={{ ...props.style.title, }}>
                    {props.node.name}
                    <span
                        className="fa-stack"
                        style={{ fontSize: 10, float: 'right', paddingTop: 10, color: 'darkgrey' }}
                        onClick={() => props.show(props.node, 'FOLDER')}
                    >
                        <i
                            className="fa fa-folder fa-stack-2x"
                            aria-hidden="true"
                            onClick={() => props.show(props.node)}
                        />
                        <i
                            style={{ marginTop: '3.em', paddingTop: 1, paddingLeft: 7, color: 'white' }}
                            className="fa fa-plus-circle fa-stack-1x"
                            aria-hidden="true"
                        />
                    </span>
                </div>
            </div >
        )
    }
    if (props.node.children && props.node.apv) {
        return (
            <div style={props.style.base}>
                <div style={{ ...props.style.title, }}>
                    {props.node.name}
                </div>
            </div>
        )
    }
    if (props.node.children) {
        return (
            <div style={props.style.base}>
                <div style={props.style.title}>
                    {props.node.done ?
                        <div style={{ display: 'inline-block', }}>
                            {props.node.name}
                            {props.node.active ?
                                <i
                                    style={{ cursor: 'pointer', paddingLeft: 5, color: 'darkgrey' }}
                                    className="fa fa-pencil"
                                    aria-hidden="true"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        props.show(props.node, 'RENAME_STATE')
                                    }}
                                />
                                : null}
                        </div>
                        :
                        <div>
                            <input
                                style={props.node.goahead ? { width: '65%' } : { width: '95%' }}
                                autoFocus
                                value={props.node.name}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => props.show(props.node, 'RENAME', e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.keyCode == 13 || e.keyCode === 27) {
                                        props.show(props.node, 'DONE')
                                    }
                                }}
                            />
                            {props.node.goahead ?
                                <div
                                    style={{ float: 'right' }}
                                >
                                    <span
                                        style={{ paddingRight: 3 }}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            props.show(props.node, 'ANNULLER_FOLDER')
                                        }}
                                    >
                                        Annuller |
                                    </span>
                                    <span
                                        onClick={() => props.show(props.node, 'DELETE_FOLDER')}
                                    >
                                        Klik for at slette
                                    </span>

                                </div>
                                :
                                <i
                                    style={{ float: 'right', paddingTop: 13, color: 'darkgrey', paddingRight: 3 }}
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        props.show(props.node, 'DELETE_FOLDER')
                                    }}
                                />}

                        </div>

                    }
                    {props.node.done ?
                        <PicFSUpload
                            className="waves-btn"
                            accept="application/pdf,image/*"
                            style={{ position: 'static', float: 'right' }}
                            onFilesSelected={files => {
                                var reader = new FileReader();
                                reader.onload = (function (f) {
                                    return function (e) {
                                        props.show(props.node, 'FILEUPLOAD', e.target.result, f.name ? f.name : 'billede' + Math.random())
                                    };
                                })(files[0]).bind(this);

                                // Read in the image file as a data URL.
                                if (files[0]) {
                                    reader.readAsDataURL(files[0]);
                                }
                            }}
                            multiple={false}>
                            <span
                                className="fa-stack"
                                style={{ fontSize: 7, float: 'right', paddingTop: 14, color: 'darkgrey', marginRight: 3 }}
                                onClick={() => props.show(props.node, 'NEWFILE')}
                            >
                                <i
                                    className="fa fa-file fa-stack-2x"
                                    aria-hidden="true"
                                    onClick={() => props.show(props.node)}
                                />
                                <i
                                    style={{ marginTop: '3.em', paddingTop: 4, paddingLeft: 5, color: 'white' }}
                                    className="fa fa-plus-circle fa-stack-1x"
                                    aria-hidden="true"
                                />
                            </span>
                        </PicFSUpload>

                        : null

                    }
                </div>
            </div>
        );
    } else {
        return (
            <div style={{ ...props.style.base, width: '98%' }}>
                <div style={props.style.title}>
                    <i
                        style={{ paddingTop: 0, cursor: 'pointer', width: 20, fontSize: 18 }}
                        className="fa fa-search"
                        aria-hidden="true"
                        onClick={() => props.show(props.node)}
                    />
                    {props.node.name}
                    {props.node.goahead ?
                        <div
                            style={{ float: 'right' }}
                        >
                            <span
                                style={{ paddingRight: 3 }}
                                onClick={() => props.show(props.node, 'ANNULLER')}
                            >
                                Annuller |
                                </span>
                            <span
                                onClick={() => props.show(props.node, 'DELETE')}
                            >
                                Klik for at slette
                                </span>

                        </div>
                        :
                        (!props.node.apv ?
                            <i
                                style={{ float: 'right', paddingTop: 13, marginRight: 5, color: 'darkgrey' }}
                                className="fa fa-trash"
                                aria-hidden="true"
                                onClick={() => props.show(props.node, 'DELETE')}
                            />
                            : null)
                    }

                </div>
            </div>
        );
    }
};
Header.propTypes = {
    style: PropTypes.object,
    node: PropTypes.object.isRequired
};



export default {
    Loading,
    Toggle,
    Header,
    Container
};



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/treebeard/components/decorators.js